// Price metadata is server-rendered in presentment-currency subunits.
// Only the new PDP loads this controller; collection cards keep unit prices.
class DwilPdpQuantityPrice extends HTMLElement {
  #observer;
  #abort;
  #frame;
  #root;
  #format;

  connectedCallback() {
    this.#root = this.closest('.shopify-section');
    if (!this.#root) return;
    this.#abort = new AbortController();
    this.#format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: this.dataset.currency,
    });
    this.#root.addEventListener('quantity-selector:update', this.#queue, { signal: this.#abort.signal });
    this.#observer = new MutationObserver(this.#queue);
    this.#observer.observe(this.#root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-dwil-unit-cents', 'data-dwil-unit-text'],
    });
    this.#queue();
  }

  disconnectedCallback() {
    this.#abort?.abort();
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
  }

  #queue = () => {
    cancelAnimationFrame(this.#frame);
    this.#frame = requestAnimationFrame(this.#update);
  };

  #update = () => {
    // Preserve native tier/range pricing if a merchant enables quantity price breaks.
    if (this.#root.querySelector('.dwil-contained-pdp__header [data-dwil-volume-pricing="true"]')) return;
    const input = this.#root.querySelector('.product-details product-form-component input[name="quantity"]');
    const quantity = Number(input?.value || 1);
    if (!Number.isSafeInteger(quantity) || quantity < 1) return;
    const prices = this.#root.querySelectorAll(
      '.dwil-contained-pdp__header [data-dwil-unit-cents], .dwil-sticky-cart__price [data-dwil-unit-cents]'
    );
    for (const price of prices) {
      const total = Number(price.dataset.dwilUnitCents) * quantity;
      if (!Number.isSafeInteger(total) || total < 0) continue;
      const suffix = price.dataset.dwilCurrencyCode === 'true' ? ` ${this.dataset.currency}` : '';
      const text = quantity === 1 ? price.dataset.dwilUnitText : this.#format.format(total / 100) + suffix;
      if (text && price.textContent !== text) price.textContent = text;
    }
  };
}

if (!customElements.get('dwil-pdp-quantity-price')) {
  customElements.define('dwil-pdp-quantity-price', DwilPdpQuantityPrice);
}
